import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressBar from './ProgressBar';
import { formatDate, isDateOverdue } from '../utils/dateUtils';

const toSlug = (name) => (name || '')
  .replace(/^[UB]\. No\. /, '')
  .replace(/\s*&\s*/g, '-')
  .replace(/\s+/g, '-');

function BungalowCard({ plot, projectCode }) {
  const navigate = useNavigate();

  const statusClass = {
    completed: 'plot-card--completed',
    active: 'plot-card--active',
    delayed: 'plot-card--delayed',
    not_started: 'plot-card--not-started'
  }[plot.status] || 'plot-card--not-started';

  const statusLabel = {
    completed: 'Completed',
    active: 'Active',
    delayed: 'Delayed',
    not_started: 'Not Started'
  }[plot.status] || 'Not Started';

  const isOverdue = plot.target_completion_date
    && plot.status !== 'completed'
    && isDateOverdue(plot.target_completion_date);

  const projectSlug = projectCode === 'SKY' ? 'skyora' : 'sylvan-villas';
  const unitSlug = toSlug(plot.bungalow_number);

  return (
    <div className={`plot-card ${statusClass}`} onClick={() => navigate(`/${projectSlug}/${unitSlug}`)}>
      <div className="plot-card-header">
        <span className="plot-card-number">{plot.bungalow_number}</span>
        {isOverdue
          ? <span className="plot-card-overdue-badge">⚠ Delayed</span>
          : <span className="plot-card-arrow">›</span>
        }
      </div>
      <div className="plot-card-stage">{plot.current_stage_name || 'Not Started'}</div>
      <div className="plot-card-progress">
        <ProgressBar percentage={plot.overall_completion || 0} />
        <span className="plot-card-percent">{plot.overall_completion || 0}%</span>
      </div>
      <div className={`plot-card-status plot-status--${plot.status}`}>{statusLabel}</div>
      <div className="plot-card-target">
        Target: {formatDate(plot.target_completion_date) || 'Not set'}
      </div>
    </div>
  );
}

export default BungalowCard;
